import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { colorTheme } from 'theme';
import { Typography, useTheme } from '@mui/material';

export interface IDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  information?: string;
}

export default function ErrorModel(props: IDialogProps): JSX.Element {
  const { title, onClose, open, information } = props;
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          <Typography variant="h4" component="h2">
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {information && (
            <DialogContentText
              id="alert-dialog-description"
              style={{ textAlign: 'center' }}
            >
              <Typography variant="h5" component="h2">
                {information}{' '}
              </Typography>
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            autoFocus
            sx={{
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
              py: 1.5,
            }}
          >
            <Typography
              variant="h5"
              style={{ fontSize: '12px', color: '#fff' }}
            >
              Close
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
